import React from 'react';
import { Zap, TrendingUp, Clock, Lightbulb, Target, Rocket } from 'lucide-react';

const WhatThisMeans = () => {
  const benefits = [
    {
      icon: Target,
      text: 'Faster material screening and optimisation'
    },
    {
      icon: TrendingUp,
      text: 'Improved structural transformation potential'
    },
    {
      icon: Clock,
      text: 'Reduced processing time compared to traditional furnaces'
    },
    {
      icon: Lightbulb,
      text: 'Opportunity to explore novel material behaviour'
    },
    {
      icon: Rocket,
      text: 'Accelerated research and development cycles'
    }
  ];

  return (
    <section id="what-this-means" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        {/* Section Title */}
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            What This Means for You
          </h2>
        </div>

        {/* Main Headline */}
        <div className="text-center mb-12">
          <h3 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8 leading-tight">
            Transform Your Materials.<br />
            Accelerate Your Discovery.
          </h3>
        </div>

        {/* Description */}
        <div className="max-w-4xl mx-auto mb-12">
          <p className="text-xl text-gray-700 leading-relaxed mb-8 text-center">
            You are not just sending a sample for heating. <strong className="text-gray-900">You are unlocking new material performance.</strong>
          </p>
          
          <p className="text-lg text-gray-600 leading-relaxed text-center mb-12">
            Our rapid high-temperature processing helps transform your materials into structures with enhanced properties 
            that may be difficult to achieve using conventional methods.
          </p>

          {/* Benefits Section */}
          <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 lg:p-12 border-2 border-green-100">
            <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              After processing, you may gain:
            </h4>
            
            <div className="space-y-4">
              {benefits.map((benefit, index) => {
                const Icon = benefit.icon;
                return (
                  <div key={index} className="flex items-start space-x-4 bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-green-600 to-blue-600 rounded-lg flex items-center justify-center">
                      <Icon className="w-5 h-5 text-white" />
                    </div>
                    <p className="text-lg text-gray-700 pt-1.5">
                      {benefit.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Closing Line */}
          <div className="mt-12 text-center">
            <p className="text-xl text-gray-800 leading-relaxed font-medium bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
              You move from idea to high-performance material faster. Your research progresses quicker, 
              your materials may perform better, and your innovation cycle shortens.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatThisMeans;
